import Vue from "vue"
import Input from "./m-input"

document.addEventListener("DOMContentLoaded", () => {
  if (!document.getElementById("companyEdit")) {
    return
  }

  window.companiesList = new Vue({
    el: "#companyEdit",
    components: { minput: Input },
    data: {
      id: Number(window.manager.data.id),
      name: window.manager.data.name,
      inn: window.manager.data.inn,
      pincode: window.manager.data.pincode,
      gorup_id: window.manager.data.gorup_id,
      discount: window.manager.data.discount,
      iiko_cat: window.manager.data.iiko_cat,
      branch: window.manager.data.branch,
      export_type: window.manager.data.export_type,
      article: window.manager.data.article,
      exportType: window.manager.data.list.export_type,
      minimalSumm: window.manager.data.minimal_summ,
      timeStart: window.manager.data.time_start,
      timeEnd: window.manager.data.time_end,
      defPayType: window.manager.data.def_pay_type,
      payTypes: window.manager.data.list.pay_types,
      conceptionList: window.manager.data.list.conception_list,
      avalPayTypes: window.manager.data.aval_pay_type,
      orderTomorrowOnly: window.manager.data.order_tomorrow_only,
      corpGUID: window.manager.data.corp_guid,
      conception: window.manager.data.conception,
      syncID: window.manager.data.sync_id,
      depositType: window.manager.data.deposit_type,
      depositTypeList: window.manager.data.list.deposit_type_list,
      depositDescription: window.manager.data.depsit_description,
      menuOnlyCompany: window.manager.data.menu_only_company,
      menuCompanyAndAll: window.manager.data.menu_company_and_all,
      activePanel: "element",
      deposit: window.manager.data.deposit_value,
      depositPrepay: window.manager.data.deposit_prepay,
      depositOverdraft: window.manager.data.deposit_overdraft,
      listBranches: window.manager.data.list.branch,
      listDiscountCats: window.manager.data.list.iiko_cat,
      author: window.manager.data.author,
      creator: window.manager.data.creator,
      modifier: window.manager.data.modifier,
      dataModified: window.manager.data.modified,
      dataCreated: window.manager.data.created,
      warehouse: window.manager.data.warehouse,
      outgoingAccount: window.manager.data.outgoingAccount,
      reckoningAccount: window.manager.data.reckoningAccount,
      warehouseList: window.manager.data.list.warehouse,
      outgoingAccountList: window.manager.data.list.outgoingAccount,
      reckoningAccountList: window.manager.data.list.reckoningAccount,
      companyID: window.manager.data.companyID,
      createUser: null,
      usersList: window.manager.data.usersList,
      modalCreateOrder: false,
      discountList: window.manager.data.list.discount,

      formErrors: [],
      updateErrors: [],
      isAjaxCall: false,
      showMesageSuccess: false,
      messageSuccess: "",
    },
    watch: {
      modalCreateOrder(isOpened) {
        if (isOpened) {
          this.onRevealModalOpened()
        } else {
          this.onRevealModelClosed()
        }
      },
    },
    methods: {
      /**
       * Обработчик собатия на открытие модалки
       */
      onRevealModalOpened() {
        $("html").addClass("is-reveal-open").addClass("zf-has-scroll")
      },
      /**
       * Обработчик события на закрытие модалки
       */
      onRevealModelClosed() {
        $("html").removeClass("is-reveal-open").removeClass("zf-has-scroll")
      },
      validate() {
        this.formErrors = []
        this.$children.map((child) => {
          child.validate()
          if (child.$options.name === "Input" && !child.isValid) {
            this.formErrors.push(" «" + child.name + "» " + child.internalMessage)
          }
        })
        return this.formErrors.length === 0
      },

      applyData(copy = false) {
        if (!this.validate()) {
          return
        }

        if (this.depositType === '46'){
          this.depositPrepay = 0;
          this.depositOverdraft = 0;
        }else{
          this.deposit = 0;
        }

        this.updateErrors = []
        let data = {
          ID: this.id,
          NAME: this.name,
          INN: this.inn,
          PROMOCODE: this.pincode,
          GROUP: this.gorup_id,
          AMOUNT_OF_DISCOUNT: this.discount,
          IIKO_DISCOUNT_CATEGORIES: this.iiko_cat,
          POINT: this.branch,
          EXPORT_TYPE: this.export_type,
          DELIVERY_CODE: this.article,
          MIN_SUMM: this.minimalSumm,
          WORKING_TIME_START: this.timeStart,
          WORKING_TIME_END: this.timeEnd,
          PAY_DEFAULT: this.defPayType,
          PAY_TYPES: this.avalPayTypes,
          ORDER_ONLY_FOR_TOMORROW: [this.orderTomorrowOnly],
          GUID_COMPANY: this.corpGUID,
          CONCEPT_ID: this.conception,
          SYNC_ID: this.syncID,
          FORMAT_DEPOSIT: this.depositType,
          DEPOSIT_DESCRIPTION: this.depositDescription,
          MENU_FOR_COMPANIES_ONLY: [this.menuOnlyCompany],
          GENERAL_MENU__MENU_FOR_COMPANIES: [this.menuCompanyAndAll],
          DEPOSIT: this.deposit,
          DEPOSIT_2: this.depositPrepay,
          DEPOSIT_2_OVERDRAFT: this.depositOverdraft,
          COPY: copy,
        }
        this.isAjaxCall = true
        fetch(window.location, {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then((data) => {
            console.log(data)
            this.isAjaxCall = false

            if (data.ERRORS) {
              this.updateErrors = data.ERRORS
              return
            }

            if (data.ID && copy) {
              window.location.href = "/manager/companies/" + data.ID + "/?copy=ok"
              return
            }

            if (this.id !== data.ID){
              console.log('refirect')
              window.location.href = "/manager/companies/" + data.ID + "/"
              return
            }
            if (data.DATA) {
              this.name = data.DATA.name
              this.inn = data.DATA.inn
              this.pincode = data.DATA.pincode
              this.gorup_id = data.DATA.gorup_id
              this.discount = data.DATA.discount
              this.iiko_cat = data.DATA.iiko_cat
              this.branch = data.DATA.branch
              this.export_type = data.DATA.export_type
              this.article = data.DATA.article
              this.exportType = data.DATA.list.export_type
              this.minimalSumm = data.DATA.minimal_summ
              this.timeStart = data.DATA.time_start
              this.timeEnd = data.DATA.time_end
              this.defPayType = data.DATA.def_pay_type
              this.payTypes = data.DATA.list.pay_types
              this.conceptionList = data.DATA.list.conception_list
              this.avalPayTypes = data.DATA.aval_pay_type
              this.orderTomorrowOnly = data.DATA.order_tomorrow_only
              this.corpGUID = data.DATA.corp_guid
              this.conception = data.DATA.conception
              this.syncID = data.DATA.sync_id
              this.depositType = data.DATA.deposit_type
              this.depositTypeList = data.DATA.list.deposit_type_list
              this.depositDescription = data.DATA.depsit_description
              this.menuOnlyCompany = data.DATA.menu_only_company
              this.menuCompanyAndAll = data.DATA.menu_company_and_all
              this.deposit = data.DATA.deposit_value
              this.depositPrepay = data.DATA.deposit_prepay
              this.depositOverdraft = data.DATA.deposit_overdraft
              this.listBranches = data.DATA.list.branch
              this.listDiscountCats = data.DATA.list.iiko_cat
              this.author = data.DATA.author
              this.modifier = data.DATA.modifier
              this.dataModified = data.DATA.modified
              this.dataCreated = data.DATA.created

              this.messageSuccess = "Изменения сохранены"
              this.showMesageSuccess = true

              setTimeout(() => {
                this.showMesageSuccess = false
                this.messageSuccess = ""
              }, 2500)
            }
          })
      },
      test() {
        this.applyData()
      },
    },
  })
})
